import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => (
  <div className="section-alt">
    <section className="section" style={{paddingTop:80,paddingBottom:80}}>
      <div className="reveal">
        <div className="eyebrow">Getting started</div>
        <h2 className="section-h2">Up and running in 3 minutes</h2>
        <p className="section-sub">From download to your first transaction — we've made it effortless.</p>
      </div>
      <div className="steps-grid reveal">
        <div className="step-card rd1"><div className="step-num">01</div><h3>Download &amp; Register</h3><p>Install SequPay from Google Play. Create your account with your mobile number — takes under 60 seconds with OTP verification.</p></div>
        <div className="step-card rd2"><div className="step-num">02</div><h3>Set Up Your Profile</h3><p>Add your name, link your bank accounts, and complete a quick KYC flow. Your data is encrypted end-to-end the moment you enter it.</p></div>
        <div className="step-card rd3"><div className="step-num">03</div><h3>Pay, Track &amp; Earn</h3><p>Send money, pay bills, track spending, and earn rewards — all from a single beautifully designed dashboard.</p></div>
      </div>
    </section>
  </div>
);

export default HowItWorks;
